import request from '@/utils/request'
const apiPath = '/temp/templateTeacher'
import { downloadBlob } from '@/utils/download'
const templateTeacherApi = {
  /**
   * 新增【技术老师宣传图】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【技术老师宣传图】
   */
  update(data) {
    return request.put(apiPath, data)
  },
   /**
   * 修改【技术老师启用状态】
   */
   updateStateBatch(data) {
    return request.post('/temp/templateTeacher/updateStateBatch', data,{isFormData: 1})
  },
  /**
   * 分页查询【技术老师宣传图】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【技术老师宣传图】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【技术老师宣传图】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【技术老师宣传图】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
}
export default templateTeacherApi
